// TODO TLC SURVEY: move to `constants.ts` file.
export const OVERVIEW_KEY = 'dashboard';
export const LINE_ITEM_PREQUAL_KEY = 'line_item_pre_qualification';
export const SUPPLIER_SCORING_KEY = 'supplier_scoring_survey';
